import { IResourceList } from 'src/components/challenge/ChallengeInterfaces';
import { ResourceTypeDetailEnum } from 'src/shared/enums';
import { IChallengeQuizTypeform } from 'src/shared/models';

const {
  QUIZ_TYPEFORM_BUTTON_TEXT,
  QUIZ_TYPEFORM_TYPEFORM_ID,
  QUIZ_TYPEFORM_TITLE,
  QUIZ_TYPEFORM_DESCRIPTION,
  QUIZ_TYPEFORM_IMAGE,
  QUIZ_TYPEFORM_VIDEO,
} = ResourceTypeDetailEnum;

export const buildChallengeQuizTypeform = (
  resource: IResourceList
): IChallengeQuizTypeform => {
  const { resourceDetailList, name: title, idResource, score } = resource;
  let item: IChallengeQuizTypeform;

  resourceDetailList
    .filter(({ status }) => status)
    .forEach(({ idResourceTypeD: { idResourceTypeD }, value }) => {
      switch (idResourceTypeD) {
        case QUIZ_TYPEFORM_BUTTON_TEXT:
          item = {
            ...item,
            buttonName: value,
          };
          break;
        case QUIZ_TYPEFORM_TYPEFORM_ID:
          item = {
            ...item,
            idTypeform: value,
          };
          break;
        case QUIZ_TYPEFORM_TITLE:
          item = {
            ...item,
            quizTitle: value,
          };
          break;
        case QUIZ_TYPEFORM_DESCRIPTION:
          item = {
            ...item,
            quizDescription: value,
          };
          break;
        case QUIZ_TYPEFORM_IMAGE:
          item = {
            ...item,
            quizImage: value,
          };
          break;
        case QUIZ_TYPEFORM_VIDEO:
          item = {
            ...item,
            quizVideo: value,
          };
          break;
      }
    });
  return { ...item, title, idResource, points: score?.points || 0 };
};
